<div class="not-found-container">
  <h1>404</h1>
  <p>Oops! The page you're looking for isn't here.</p>
  <p>You might have the wrong address, or the page may have moved.</p>
  <button mat-raised-button routerLink="/" class="home-link" color="primary">
    Back to Home
  </button>
</div>
